import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../../../core';
import { PedidoDRP } from '../../../drp';

interface Config {
    canShowQV: boolean;
    canShowDRP: boolean;
}

@Component({
    selector: 'sgt-pedido-nao-liberado-card-info-lucro-liquido-abaixo',
    templateUrl: './pedido-nao-liberado-card-info-lucro-liquido-abaixo.component.html',
    styleUrls: ['./pedido-nao-liberado-card-info-lucro-liquido-abaixo.component.less']
})
export class PedidoNaoLiberadoCardInfoLucroLiquidoAbaixoComponent implements OnInit {
    config: Config = {
        canShowQV: false,
        canShowDRP: false
    };

    @Input() tipoVenda: number;
    @Input() dataNaoLiberado: Date;
    @Input() drp: PedidoDRP;

    constructor(private authService: AuthService) { }

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            canShowQV: this.authService.podeVisualizarQV(),
            canShowDRP: this.authService.podeVisualizarDRP()
        };
    }
}
